import React, { useState } from "react";

type LoginFormProps = {
  onSubmit: (username: string, password: string) => Promise<void>;
  isSubmitting: boolean;
  errorMessage?: string | null;
};

const LoginForm = ({ onSubmit, isSubmitting, errorMessage }: LoginFormProps) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit(username.trim(), password);
  };

  return (
    <form onSubmit={handleLogin} className="manual-login__form">
      <div className="manual-login__input">
        <input
          type="text"
          placeholder="Username"
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          disabled={isSubmitting}
        />
      </div>
      <div className="manual-login__input">
        <input
          type="password"
          placeholder="Password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={isSubmitting}
        />
      </div>
      {errorMessage ? (
        <p className="manual-login__error">{errorMessage}</p>
      ) : null}
      <button className="btn blue-btn manual-login__submit" type="submit" disabled={isSubmitting}>
        {isSubmitting ? "Logging in..." : "Login"}
      </button>
    </form>
  );
};

export default LoginForm;
